import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, notification } from 'antd';

const NOTIF_KEY = 'optimiser-exclusion-warning';

const OptimiserExclusionWarning = ({ visible, onClose }) => {
  useEffect(() => {
    if (!visible) {
      return;
    }
    const handleOk = () => {
      notification.close(NOTIF_KEY);
      onClose();
    };
    const btn = (
      <Button size="small" type="primary" onClick={handleOk}>
        OK
      </Button>
    );
    notification.warning({
      key: NOTIF_KEY,
      message: 'User excluded from Optimiser',
      description: 'User is now excluded from the optimiser. Be aware that this user is rostered within the next 6 months and will not be able to be optimised.',
      placement: 'bottomRight',
      duration: 0,
      btn,
      onClose
    });
  }, [visible]);

  return null;
};

OptimiserExclusionWarning.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func
};

OptimiserExclusionWarning.defaultProps = {
  visible: false,
  onClose() {}
};

export default OptimiserExclusionWarning;
